import React, { useRef } from 'react'
// Link not used in this file
import './blog.css';
import './home.css';
import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'
import picture from './components/posts/25-26/pictures/MM1.jpeg'

const Involved = () => {
  const ref = useRef(null);

  return (
    <div>
      <br></br>
      <div className='blog__container'>
        <div className="row">
          <br></br>
          <div className="words first-column">
              <div class className="teamTitle-wrapper">
                <p id="teamTitle">Get Involved With UW WiC!</p>
              </div>
            <div>
               <div className="words">
                <div className="spread">
                  <h2><a href="https://forms.gle/mERtbiwM77HQFUE49"><button class="wic-events-button">WiC Membership Form</button></a></h2>
                  <h2><a href="https://mailman.cs.washington.edu/mailman/listinfo/wic"><button class="wic-events-button">WiC Mailing List</button></a></h2>
                  <h2><a href="https://discord.com/invite/Zp4GVB7ddq"><button class="wic-events-button">WiC Discord Server</button></a></h2>
                </div>
                <img src={picture} alt="WiC members at an event!" width= "100%" height="100%"></img>
               </div>
               <hr></hr>
               <div className="words">
                    <h1>Frequently Asked Questions</h1>
                    <h3 className="rounded title-padding">What is the time commitment for being a WiC member?</h3>
                    <p>There is no strict attendance requirement for WiC members, but we encourage you to attend as many of our events as you can! However, being part of a WiC committee would be an additional time commitment.</p>

                    <h3 className="rounded title-padding">Do you have to be a CS/CE to join WiC?</h3>
                    <p>Yes, WiC is an Allen School RSO for students majoring in CS/CE</p>

                    <h3 className="rounded title-padding">How can I join a committee or run as an officer? When do applications come out?</h3>
                    <p>Applications to run for officer for the next academic year will be out in April. The applications to run for a committee for the current academic year is in September.</p>

                    <h3 className="rounded title-padding">Who can I contact if I have questions?</h3>
                    <p>You can email the WiC officers at: wic-officers@cs.washington.edu</p>
 
               </div>
            </div>
          </div> 
        </div>
    </div>

      <div className='actions' ref={ref}>
      <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' rel="noreferrer" className='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank' rel="noreferrer" className='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
        <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' aria-label="Instagram" target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' aria-label="Facebook" target='_blank' rel="noreferrer"><BsFacebook/></a>
          <a id='discord' href='https://discord.gg/Zp4GVB7ddq' aria-label="Discord" target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" className='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Involved;



